(function () {
  const SELECTS = document.querySelectorAll(".kontakt_box select, .info-popup select");
  SELECTS.forEach(function (select) {
    select.options[0].value = "";
  });
})();
